import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import Tip from './Tip';
import { SSpacedRowWrapped } from 'styles/layout';

const ListTip: FC = () => {
    const { t } = useTranslation();

    const a = t('help.list-tips', { escapeValue: true, returnObjects: true }) as string[];

    return (
        <SSpacedRowWrapped>
            {a.map((e: string, i: number) => (
                <Tip key={e} content={e} number={i + 1} />
            ))}
        </SSpacedRowWrapped>
    );
};

export default ListTip;
